<template>
  <div class="l-auth-container">
    <h1>yesloyal Business Sign Up</h1>
        <a-card class="l-auth">
          <a-form v-if="!user">
            <a-form-item label="Email"
                         :label-col="{ span: 5 }"
                         :validate-status="errors.has('email') ? 'error' : null"
                         :help="errors.first('email')"
                         :wrapper-col="{ span: 12 }">
              <a-input
                name="email"
                v-validate="'required|email'"
                v-model="credentials.email">
              </a-input>
            </a-form-item>
            <a-form-item :label-col="{ span: 5 }"
                         :wrapper-col="{ span: 12 }"
                         :validate-status="errors.has('password') ? 'error' : null"
                         :help="errors.first('password')"
                         label="Password">
              <a-input
                name="password"
                type="password"
                v-validate="'required|min:6'"
                v-model="credentials.password">
              </a-input>
            </a-form-item>
            <a-form-item :label-col="{ span: 5 }"
                         :wrapper-col="{ span: 12 }"
                         :validate-status="errors.has('business name') ? 'error' : null"
                         :help="errors.first('business name')"
                         label="Business Name">
              <a-input
                name="business name"
                v-validate="'required|min:2'"
                v-model="credentials.businessName">
              </a-input>
            </a-form-item>
            <div style="margin-bottom: 20px">
              your subdomain will be <span v-if=credentials.businessName>{{subdomain}}</span><span v-else>XXX</span>{{DOMAIN}}
            </div>

            <div style="display: flex;justify-content: space-between;max-width: 450px;">
              <a-button class=""
                        style="margin: 0;"
                        type="primary"
                        @click="signUp()">
                Sign Up
              </a-button>
            </div>
          </a-form>
          <div v-else>
            <p>You've registered successfully.</p>
            <p>Your login domain is <a :href="`//${subdomain}${DOMAIN}`">{{subdomain}}{{DOMAIN}}</a></p>
          </div>
        </a-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import {DOMAIN} from '../../constants'

export default {
  name: 'Registration',
  data () {
    return {
      snackbar: false,
      validLogin: false,
      validSignUp: false,
      signUpVisible: false,
      loginPasswordVisible: false,
      signUpPasswordVisible: false,
      // rules: [ (value) => !!value || 'This field is required' ],
      credentials: {
        email: '',
        password: '',
        businessName: '',
      },
      newUser: {
        username: '',
        password: '',
      },
      message: '',
      DOMAIN,
    }
  },
  methods: {
    async signUp () {
      const result = await this.$validator.validateAll()
      if (result) {
        this.$store.dispatch('auth/signUp', this.credentials)
      }
    },
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    subdomain () {
      if (!this.credentials.businessName) {
        return ''
      }
      return this.credentials.businessName.replace(/\W/g, '').toLocaleLowerCase()
    }
  },
}
</script>

<style lang="scss">
  @import "./../../assets/styles";
  .l-auth-container {
    text-align: center;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    background: #fff
  }

  .l-auth, .ant-tabs {
    padding: 15px;
    width: 100%;
    max-width: 600px;
    margin: 45px auto;
    //animation: bounceIn 1s forwards ease;
  }
  @media screen and (max-width: 800px) {
    .ant-tabs-bar {
      border: 0;
    }
    h1{
      font-size: 27px;
    }
    .l-auth, .ant-tabs{
      width: 100%;
      max-width: 450px;
    }
    .ant-card-body {
      padding: 0;
    }
    .ant-layout {
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Authentication/Registration.vue